import React from 'react';

interface IProps {
	children: string;
}

export const StatusBadge = (props: IProps) => {
	const status: string = props.children;
	// We gonna lowercase it first.. for any case ;)
	switch (status.toLowerCase()) {
		case 'bought':
			return <span className='badge badge-success' style={{
				backgroundColor: '#4d5ae9'
			}}>{status}</span>;
		case 'refunded':
			return <span className='badge badge-success' style={{
				backgroundColor: '#FF5244'
			}}>{status}</span>;
		case 'checkedin':
			return <span className='badge badge-success' style={{
				backgroundColor: '#07ba76'
			}}>checked-in</span>;
		case 'partiallycheckedin':
			return <span className='badge badge-success' style={{
				backgroundColor: '#07ba76'
			}}>partially<br />checked-in</span>;
		case 'cancelled':
			return <span className='badge badge-danger' style={{
				backgroundColor: '#FF5244'
			}}>voided</span>;
		case 'activated':
			return <span className='badge badge-info' style={{
				backgroundColor: '#262745'
			}}>pending<br />purchase</span>;
		default:
			return <span className='badge badge-default'>{status}</span>;
	}
};



// WEBPACK FOOTER //
// ./src/components/misc/StatusBadge/StatusBadge.tsx